<!-- DEFAULT HEADER -->
<div class="border-bottom navy-bg public-nav">
	<div class="container">
		<nav
			class="row navbar navbar-static-top mb-0"
			role="navigation">
			<div class="col-lg-5">
				<a routerLink="/" class="logo-link">
					<img
						title="InfoDocs Logo Colour Transparent"
						src="assets/img/infodocs-logo.png"
						class="logo"
					/>
				</a>
			</div>
			<div class="col-lg-7"></div>
		</nav>
	</div>
</div>
